import { useEffect, useRef, type CSSProperties } from "react";

const base = import.meta.env.BASE_URL;

const logos = [
  { src: `${base}logos/google-ticker.webp`, alt: "Google", height: 40, width: 121 },
  { src: `${base}logos/microsoft-ticker.webp`, alt: "Microsoft", height: 32, width: 150 },
  { src: `${base}logos/accenture-ticker.webp`, alt: "Accenture", height: 40, width: 152 },
  { src: `${base}logos/forbes-ticker.webp`, alt: "Forbes", height: 32, width: 127 },
  { src: `${base}logos/relman-colfax-ticker.webp`, alt: "Relman Colfax", height: 44, width: 109 },
  { src: `${base}logos/gonzaga-ticker.webp`, alt: "Gonzaga University", height: 32, width: 139 },
  { src: `${base}logos/capital-eleven-ticker.webp`, alt: "Capital Eleven", height: 72, width: 89 },
  { src: `${base}logos/true-equity.webp`, alt: "True Equity", height: 36, width: 181 },
  { src: `${base}logos/radicle-impact.webp`, alt: "Radicle Impact", height: 32, width: 174 },
  { src: `${base}logos/scubed.webp`, alt: "S-Cubed Capital", height: 60, width: 45 },
  { src: `${base}logos/sand-hill-east.webp`, alt: "Sand Hill East", height: 36, width: 229 },
];

export function LogoTicker() {
  const trackRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const track = trackRef.current;
    if (!track) return;

    let animationId: number;
    let position = 0;
    let halfWidth = track.scrollWidth / 2;
    const speed = 0.5;
    const resizeObserver = new ResizeObserver(() => {
      halfWidth = track.scrollWidth / 2;
    });
    resizeObserver.observe(track);

    const animate = () => {
      position -= speed;
      if (halfWidth > 0 && Math.abs(position) >= halfWidth) {
        position = 0;
      }
      track.style.transform = `translateX(${position}px)`;
      animationId = requestAnimationFrame(animate);
    };

    animationId = requestAnimationFrame(animate);
    return () => {
      cancelAnimationFrame(animationId);
      resizeObserver.disconnect();
    };
  }, []);

  return (
    <section className="bg-black border-b border-border/40 pt-6 pb-10 overflow-hidden">
      <p className="hidden md:block text-center text-xs uppercase tracking-widest text-muted-foreground mb-6">Validated by</p>
      <div style={{ overflow: "hidden", width: "100%" }}>
        <div
          ref={trackRef}
          style={{ display: "flex", alignItems: "center", width: "max-content", willChange: "transform" }}
        >
          {[...logos, ...logos].map((logo, i) => (
            <div
              key={i}
              className="logo-ticker-item"
              style={{
                "--logo-width": `${logo.width}px`,
                "--logo-height": `${logo.height}px`,
                "--logo-mobile-width": `${Math.round(logo.width * 0.65)}px`,
                "--logo-mobile-height": `${Math.round(logo.height * 0.65)}px`,
              } as CSSProperties}
            >
              <img
                src={logo.src}
                alt={`${logo.alt} logo`}
                width={logo.width}
                height={logo.height}
                loading="lazy"
                decoding="async"
                className="logo-ticker-image"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
